// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__2tXT6"};


//////////////////
// WEBPACK FOOTER
// ./src/Hoc/Layout/Layout.css
// module id = 35
// module chunks = 0